<div class="mat-table-wrapper">
    <table mat-table [dataSource]="dataSource" class="w-full">
        @if (options.includeRowNumbers) {
            <ng-container matColumnDef="no">
                <th mat-header-cell *matHeaderCellDef>#</th>
                <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    {{ 'label_total' | translate }}
                </td>
            </ng-container>
        }
        <ng-content></ng-content>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
                <mat-icon class="icon-size-5 relative top-1" fontIcon="more_horiz"></mat-icon>
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
                <div class="flex">
                    @if (options.allowRowRefresh) {
                        <button
                            mat-icon-button
                            type="button"
                            matTooltipShowDelay="500"
                            [matTooltip]="'label_fetch_information' | translate"
                            (click)="onRefreshRow(element)"
                        >
                            <mat-icon class="icon-size-5" fontIcon="refresh"></mat-icon>
                        </button>
                    }
                    @if (options.allowRowReorder) {
                        <button
                            [disabled]="i == 0"
                            mat-icon-button
                            type="button"
                            matTooltipShowDelay="500"
                            [matTooltip]="'label_move_up' | translate"
                            (click)="onMoveRow(element, 'up')"
                        >
                            <mat-icon class="icon-size-5" fontIcon="keyboard_arrow_up"></mat-icon>
                        </button>
                    }
                    @if (options.allowRowReorder) {
                        <button
                            [disabled]="i == _data.length - 1"
                            mat-icon-button
                            type="button"
                            matTooltipShowDelay="500"
                            [matTooltip]="'label_move_down' | translate"
                            (click)="onMoveRow(element, 'down')"
                        >
                            <mat-icon class="icon-size-5" fontIcon="keyboard_arrow_down"></mat-icon>
                        </button>
                    }
                    @if (options.allowRowDeletion) {
                        <button
                            mat-icon-button
                            type="button"
                            matTooltipShowDelay="500"
                            [matTooltip]="'label_delete' | translate"
                            (click)="onRemoveRow(element)"
                        >
                            <mat-icon class="icon-size-5" fontIcon="delete"></mat-icon>
                        </button>
                    }
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        @if (options.includeFooterRow) {
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        }
    </table>
</div>
